module.exports = __webpack_public_path__ + "img/just_text_dark2.955e1480.png";